import {
    CENTRO_CUSTO_MODO_TELA,
    CENTRO_CUSTO_SET_AGUARDANDO,
    CENTRO_CUSTO_LISTADO
} from './centroCustoActions';

const INITIAL_STATE = {
    registro: {},
    modoTela: 'lista',
    aguardando: false,
    lista: [],
    listaSelect: []
};

export default (
    state = INITIAL_STATE,
    action
) => {
    switch (action.type) {
        case CENTRO_CUSTO_MODO_TELA:
            return {
                ...state,
                modoTela: action.payload.modo,
                registro:
                    action.payload.registro || {}
            };

        case CENTRO_CUSTO_SET_AGUARDANDO:
            return {
                ...state,
                aguardando: action.payload
            };

        case CENTRO_CUSTO_LISTADO: {
            const lista =
                action.payload.data || [];

            return {
                ...state,
                lista,

                listaSelect: lista.map(item => ({
                    id: item.id,
                    valor: `${
                        item.codigo
                            ? `${item.codigo} - `
                            : ''
                    }${item.nome || ''}`
                }))
            };
        }

        default:
            return state;
    }
};